module.exports = __webpack_public_path__ + "img/2.disabled.7bded03b.svg";